import { FILTERS } from '../constants';

const getFilteredWell = (field, filter) => {
  return !filter || filter.length === 0 || filter.includes(field);
};

export function getFilteredWells(dynamicFilters, excludeSideTrack, allWells) {
  const sideTrackStrRegex = /\sST0/g;
  if (!allWells) return allWells;
  const filteredWells = Object.values(FILTERS).reduce((result, filterKey) => {
    return result.filter(well => getFilteredWell(well[filterKey], dynamicFilters[filterKey]));
  }, allWells);
  return filteredWells.filter(
    well => (excludeSideTrack && !well.name.match(sideTrackStrRegex)) || !excludeSideTrack
  );
}

export function getFilteredWellsByNonEngineered(wells, includeNonEngineeredWells) {
  const nonEngineeredNames = ['non-engineered', 'non engineered'];
  if (!wells) return wells;
  return includeNonEngineeredWells
    ? wells
    : wells.filter(well =>
        nonEngineeredNames.every(item => well.name?.toLowerCase().search(item) === -1)
      );
}
